export class AssociateUserPrjIN {
    idProgetto: number
    listIdUser: number[]
}
